import React from 'react';
import ReportingMarketingWebPage from '../components/ReportingMarketingWebPage';

const ReportingMarketingWebApp = (props) => (
  <ReportingMarketingWebPage {...props} />
);

export default ReportingMarketingWebApp;
